module.exports = __webpack_public_path__ + "static/media/estacao-fixa.8eee56b4.png";